<template>
  <Authenticated>
    <section class="container">
      <h1>Web Settings for {{ site }}</h1>
      <!-- @update:modelValue="saveSetting('openClose', $event)" -->
      <div class="settings">
        <!-- a section to edit the header in the web -->
        <div class="title">
          <h2>Manage General Settings</h2>
        </div>
        <div class="all-settings section">
          <div class="delivery-settings">
            <div class="delivery">
              <div class="tog">
                <label for="open-close">Close Website:</label>
                <ToggleSwitch :onLabel="'Closed'" :offLabel="'Open'" :modelValue="openClose" :modelName="'openClose'" @update:modelValue="updateWeb($event)" />
              </div>
              <div class="tog">
                <label for="delivery_settings">Delivery:</label>
                <ToggleSwitch
                  :onLabel="'Enabled'"
                  :offLabel="'Disabled'"
                  :modelValue="delivery"
                  :modelName="'delivery_settings'"
                  @update:modelValue="saveSetting('delivery_settings', $event)" />
              </div>
            </div>
            <div v-if="delivery" class="manage-section">
              <div class="manage" @click.stop.prevent="openOperatingHours = !openOperatingHours">
                <p>Manage Delivery Hours</p>
              </div>
              <router-link v-if="site != 'catering'" class="manage" :to="`/deliveryzone/${site}`">Manage Delivery Zone</router-link>
            </div>
          </div>
        </div>
        <div class="title">
          <h2>Manage Web Header Settings</h2>
          <button class="button is-primary action-colour" @click.stop.prevent="updateSettings">Save Web Header Settings</button>
        </div>
        <div class="header-settings section">
          <div class="input-fields">
            <div class="inputs">
              <label for="site_name">Site Name:</label>
              <input id="site_name" type="text" v-model="settings.site_name" />
            </div>
            <div class="inputs">
              <label for="site_description">Site Description:</label>
              <input id="site_description" type="text" v-model="settings.site_description" />
            </div>
          </div>
          <div class="logo-section">
            <h3>Current Logo:</h3>
            <img :src="getLogoViaSite(site)" alt="Site Logo" />
            <button class="button is-primary action-colour" @click.stop.prevent="openImgModal">Adjust Logo</button>
          </div>
        </div>
      </div>
    </section>
    <ImageUploadModal :showModal="showImgModal" @saveLogo="saveLogo" @closeImgModal="closeImgModal" />
    <OperatingHours @closeModal="openOperatingHours = !openOperatingHours" :currentSite="site" :openModal="openOperatingHours" />
  </Authenticated>
</template>

<script>
import Authenticated from "../_layouts/Authenticated.vue";
import { mapGetters } from "vuex";
import { ToggleSwitch, OperatingHours } from "@monolith/components";
import ImageUploadModal from "./ImageUploadModal.vue";

export default {
  name: "WebSettings",
  components: {
    Authenticated,
    ToggleSwitch,
    ImageUploadModal,
    OperatingHours,
  },
  data() {
    return {
      site: this.$route.params.site, // Initialize site data
      settings: {
        site_name: "",
        site_description: "",
        logo: "",
      }, // Initialize settings data
      savedLogo: "", // Initialize savedLogo data
      newLogo: "", // Initialize newLogo data
      openClose: false,
      showImgModal: false, // Initialize showImgModal data
      openOperatingHours: false,
      delivery: false, // Initialize delivery state
    };
  },
  computed: {
    ...mapGetters({
      companyName: "companyName",
      companySettings: "companySettings",
      siteSettings: "siteSettings",
      webSettingsViaSite: "webSettingsViaSite",
      getLogoViaSite: "getLogoViaSite",
    }),
  },
  async mounted() {
    this.settings = await this.webSettingsViaSite(this.site);
    this.savedLogo = this.settings.logo; // Set the saved logo to the current logo
    this.openClose = this.siteSettings[this.site].openClose;
    this.delivery = this.siteSettings[this.site].delivery_settings;
  },
  methods: {
    saveSetting(s, value) {
      if (s == "delivery_settings") {
        this.delivery = value; // Update the delivery state
      }
      this.channel.push("company:site:setting", { site: this.site, key: s, value: value }).receive("ok", () => {
        if (s == "openClose") {
          this.channel.push("company:site:close", { site: this.site, status: value }).receive("ok", () => {});
        }
      });
    },

    updateWeb(value) {
      this.$hours.updateUnschedule(value)
      this.channel.push("company:site:close", { site: this.site, status: value });
    },

    openImgModal() {
      this.showImgModal = true; // Show the image upload modal
    },
    closeImgModal() {
      this.showImgModal = false; // Close the image upload modal
    },
    saveLogo(newLogo) {
      this.newLogo = newLogo; // Set the new logo
      this.updateSettings(); // Update the settings with the new logo
      this.closeImgModal(); // Close the image upload modal
    },

    updateSettings() {
      if (!this.newLogo) {
        this.newLogo = this.savedLogo; // If no new logo, use the saved logo
      }
      this.savedLogo = this.newLogo; // Update the saved logo to the new logo for viewing
      this.settings.logo = this.newLogo; // only update the logo on save
      let updatedSettings = {
        site_name: this.settings.site_name,
        site_description: this.settings.site_description,
        logo: this.settings.logo,
      };
      Object.entries(updatedSettings).forEach(([key, value]) => {
        if (value != undefined) {
          this.channel.push("company:site:setting", { site: this.site, key: key, value: value }).receive("ok", () => {
            this.$store.dispatch("getAllData");
          }); //save the settings to the channel
        }
      });
      // this.$router.push(`/web/`); //go back to the previous page
    },
  },
  watch: {},
};
</script>

<style scoped lang="scss">
.container {
  display: block;
  padding: 0 1rem;

  h1 {
    text-transform: capitalize;
    text-align: center;
  }

  .open-close {
    margin: 1rem;
  }

  .section {
    margin: 0.5rem 1rem;
    display: flex;
    flex-direction: column;
    padding: 0.5rem;
    border-radius: 10px;
    box-shadow: var(--box-shadow);
  }

  .settings {
    display: flex;
    flex-direction: column;
    width: 100%;

    .title {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      h2 {
        margin: 1rem;
      }
    }

    .button {
      background-color: var(--action-colour);
      color: var(--secondary-text-colour);
    }

    .header-settings {
      background: var(--primary-colour);
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: flex-start;
      padding: 1rem;
      .logo-section {
        width: 50%;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        margin: 0 2rem;
        img {
          background-color: var(--tertiary-colour);
          width: 100%;
          border-radius: 10px;
          box-shadow: var(--box-shadow);
        }
        button {
          margin: 1.5rem 0;
          width: 100%;
        }
      }
      .input-fields {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 50%;
        .inputs {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: flex-start;
          padding: 1rem;
          margin: 0.25rem;
          width: 100%;
          label {
            font-size: larger;
            margin: 0.5rem;
          }
          input {
            background: var(--tertiary-colour);
            box-shadow: var(--box-shadow);
            color: var(--text-colour);
            border: none;
            font-size: 1.25rem;
            border-radius: 5px;
            padding: 1rem;
            margin: 0.25rem;
            width: calc(100% - 2rem);
          }
        }
      }
    }

    .opHours {
      margin: 1rem;
      padding: 1rem;
      background-color: var(--tertiary-colour);
      border-radius: 5px;
      box-shadow: var(--box-shadow);
      text-decoration: none;
      color: var(--text-colour);
      font-size: larger;
      text-transform: capitalize;
    }

    .all-settings {
      background-color: var(--primary-colour);
      display: flex;
      flex-direction: column;
      height: 50%;
      padding: 1rem;

      .delivery-settings {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        min-width: 100%;
        .delivery {
          display: flex;
          flex-direction: row;
          align-items: center;
          .tog {
            display: flex;
            flex-direction: column;
            align-items: center;
            margin: 0.5rem 0;
            label {
              font-size: larger;
            }
          }
        }
        .manage-section {
          display: flex;
          flex-direction: row;
          .manage {
            align-content: center;
            margin: 1rem;
            padding: 1rem;
            background-color: var(--tertiary-colour);
            border-radius: 5px;
            box-shadow: var(--box-shadow);
            text-decoration: none;
            color: var(--text-colour);
            font-size: larger;
            text-transform: capitalize;
            cursor: pointer;
            p {
              margin: 0;
            }
          }
        }
      }
    }
  }
}

@media only screen and (orientation: portrait) {
  .container {
    max-width: 90%;
    margin: 0;
    .section {
      margin: 0;
    }
    .settings {
      .all-settings {
        .delivery-settings {
          display: flex;
          flex-direction: column;
          .delivery {
            margin: auto;
          }
        }
      }

      .title {
        max-width: 100%;
        display: flex;
        flex-direction: column;
        button {
          margin-bottom: 1rem;
        }
      }

      .header-settings {
        flex-direction: column;
        .input-fields {
          width: 100%;
          input {
            max-width: 88%;
          }
        }

        .logo-section {
          margin: auto;
        }

        .images {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
        }
      }
    }
  }
}
</style>
